import { render, staticRenderFns } from "./WorkersHistoryPage.vue?vue&type=template&id=2cd39e8c&"
import script from "./WorkersHistoryPage.vue?vue&type=script&lang=js&"
export * from "./WorkersHistoryPage.vue?vue&type=script&lang=js&"
import style0 from "./WorkersHistoryPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VDataTable,VDatePicker,VDivider,VFlex,VLayout,VMenu,VPagination,VTextField})
